<template>
  <div>
    <header>
      <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/materialize/1.0.0/css/materialize.min.css">
      <!-- Include CSS do MDB -->
      <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/mdb-ui-kit/6.4.1/mdb.min.css">
    </header>
    <div class="container mt-5 mb-5">
      <div class="icon-container container-menu">
        <i v-if="isClone" @click="openModalRestSoap" class="fas fa-plus"></i>

      </div>
    </div>

    <div v-for="catalogoMenu in listaFiltrada" :key="String(catalogoMenu.tipo) + '-' + String(catalogoMenu.codigo)">
      <MenuTabs :titulo="catalogoMenu.descricao" :codigo="String(catalogoMenu.codigo)" :menu="menuAtivo || ''"
        @onAction="onActionInComponent" @onActionAtribute="onActionAtributeInComponent" />
    </div>


    <div class="m-3 mt-5" role="group" aria-label="Basic example">
      <div class="row">
        <template v-if="isREST">
          <div v-if="!isClone" class="col-8">
            <a href="/massificados/corporativo/gerenciador-parceiros-ui/#/consulta-catalogo">
              <button type="button" id="vendas" class="footer-button btn btn-primary btn-return" data-mdb-ripple-init>
                VOLTAR
              </button>
            </a>
          </div>

          <div v-if="isClone" class="back-button col-6">
            <a href="/massificados/corporativo/gerenciador-parceiros-ui/#/consulta-catalogo">
              <button type="button" id="vendas" class="footer-button btn btn-primary btn-return" data-mdb-ripple-init>
                VOLTAR
              </button>
            </a>
          </div>

          <div v-if="isClone" class="publish-button col-2">
            <button type="button" @click="confirmacaoPublicar" id="pos-venda"
              class="footer-button-active btn btn-primary active" data-mdb-ripple-init>
              PUBLICAR
            </button>
          </div>

          <div class="col-2 save-column">
            <button type="button" @click="salvarDados" id="gestao-carteira"
              class="footer-button-active btn btn-primary active save-btn" data-mdb-ripple-init>
              SALVAR
            </button>
          </div>
        </template>

        <template v-else>
          <div class="col-6">
            <a href="/massificados/corporativo/gerenciador-parceiros-ui/#/consulta-catalogo">
              <button type="button" id="vendas" class="footer-button btn btn-primary btn-return" data-mdb-ripple-init>
                VOLTAR
              </button>
            </a>
          </div>

          <div class="col-3">
            <button type="button" @click="salvarDados" id="gestao-carteira"
              class="footer-button btn btn-primary save-btn" data-mdb-ripple-init>
              SALVAR
            </button>
          </div>

          <div v-if="isClone" class="col-2">
            <button type="button" @click="confirmacaoPublicar" id="pos-venda"
              class="footer-button-active btn btn-primary active" data-mdb-ripple-init>
              PUBLICAR
            </button>
          </div>
        </template>
      </div>
    </div>
    <!-- MODAL REST / SOAP -->
    <div v-if="showModalRestSoap" class="modal modal-rest-soap fade show" tabindex="-1" aria-modal="true" role="dialog"
      style="display:block;">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" style="font-weight: 600;">Adicionar Menu</h5>
            <button type="button" class="btn-close" @click="closeModalRestSoap"></button>
          </div>



          <div class="modal-body">
            <div class="col-12 col-sm-12 col-md-3 m-3">
              <div class="form-outline">
                <div class="textarea-container mt-5">
                  <label class="green-label" for="textareaId">Nome do menu:</label>
                  <input id="nomeMenu" ref="nomeMenu" class="form-control input-modal" v-model.trim="nomeMenu" required>

                </div>
              </div>
            </div>
          </div>


          <div class="m-3 mt-4">
            <div class="row m-1">
              <div class="col-5">
                <button class="footer-button btn btn-primary" style="width: 105% !important;"
                  @click="closeModalRestSoap">
                  CANCELAR
                </button>
              </div>
              <div class="col-1"></div>
              <div class="col-3">
                <button class="footer-button btn btn-primary active save-btn"
                  style="width: 205% !important;color:white !important" @click="salvarNovoMenu()">
                  SALVAR
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-if="showModalRestSoap" class="modal-backdrop fade show"></div>


  </div>
</template>

<script>
import MenuTabs from '@/components/MenuTabs.vue';
import * as loaderUtils from '@/utils/loader';
import * as validadorUtils from '@/utils/validador';

import * as ajaxUtils from '@/utils/ajax';
import * as alertUtils from '@/utils/alert';



export default {
  name: 'RestSoap',
  components: { MenuTabs },

  props: {
    tipo: { type: String, required: true },
    clone: { type: [Boolean, String], default: false },
    listas: { type: Object, default: () => ({}) },
    listaMenuCatalogoApi: { type: Array, default: () => [] },
    idCatalogo: { type: [String, Number], required: false, default: '' }
  },

  data() {
    return {

      menuAtivo: '',
      showModalRestSoap: false,
      nomeMenu: ''
    };
  },

  computed: {
    isClone() {
      return this.clone === true || String(this.clone) === 'true';
    },
    listaFiltrada() {
      const t = this.isSOAP ? 'S' : 'R';
      return (this.listaDadosRestSoap || []).filter(m => String(m.tipo) === t);
    },
    isREST() {
      return String(this.tipo).toUpperCase() === 'REST';
    },

    isSOAP() {
      return String(this.tipo).toUpperCase() === 'SOAP';
    },

    listaDadosRestSoap() {
      const menus = Array.isArray(this.listaMenuCatalogoApi) && this.listaMenuCatalogoApi.length
        ? this.listaMenuCatalogoApi
        : (this.listas && Array.isArray(this.listas.listaMenuCatalogoApi) ? this.listas.listaMenuCatalogoApi : []);

      return menus || [];
    },

    ultimoCodigoMenu() {
      const menus = (this.listas && Array.isArray(this.listas.listaMenuCatalogoApi))
        ? this.listas.listaMenuCatalogoApi
        : [];

      // pega o maior codigo existente (fallback 0)
      return menus.reduce((max, m) => {
        const c = Number(m.codigo);
        return Number.isFinite(c) ? Math.max(max, c) : max;
      }, 0);
    }
  },

  methods: {

    salvarDados() {

      this.$emit('salvar-dados');
    },

    confirmacaoPublicar() {
      this.$emit('confirmacao-publicar');
    },
    openModalRestSoap() {
      if (!this.isClone) return;
      this.nomeMenu = '';
      this.showModalRestSoap = true;

      this.$nextTick(() => {
        const el = this.$refs.nomeMenu;
        if (el) el.focus();
      });
    },

    setandoMenuAtivo(id) {
      this.$emit('setando-menu-ativo', id);
    },


    onActionInComponent(payload) {

      const codigoExcluido = (payload && payload.type) ? String(payload.codigoMenu) : String(payload);

      const novaLista = (this.listaDadosRestSoap || []).filter(m => String(m.codigo) !== codigoExcluido);

      this.$emit('atualizar-listas', { listaMenuCatalogoApi: novaLista });

      this.$emit('on-action-in-menu', {
        tipo: this.tipo,
        origem: 'MenuTabs',
        action: payload
      });
    },



    onActionAtributeInComponent(payload) {
      this.$emit('on-action-in-menu', {
        tipo: this.tipo,
        origem: 'MenuTabs',
        actionAtribute: payload
      });
    },

    closeModalRestSoap() {
      this.showModalRestSoap = false;
      this.nomeMenu = '';
    },

    async salvarNovoMenu() {
      loaderUtils.addLoarder();

      try {
        const nomeMenu = (this.nomeMenu || '').trim();
        if (!nomeMenu) {
          alertUtils.alertError('É obrigatório informar o nome do menu!', 'Fechar');
          return false;
        }

        const tipo = (String(this.tipo).toUpperCase() === 'SOAP') ? 'S' : 'R';
        const nomeTipo = (tipo === 'S') ? 'soap' : 'rest';

        const bodyData = {
          codigo: this.ultimoCodigoMenu + 1,
          tipo,
          descricao: nomeMenu
        };

        const erro = validadorUtils.validarCamposObrigatorios(bodyData, ['descricao']);
        if (erro) return false;

        const urlApi =
          '/massificados/corporativo/gerenciador-parceiros/rest/manutencao-catalogo-servico/incluir-menu-catalogo/' +
          tipo +
          '/' +
          this.idCatalogo;

        const jsonRequest = JSON.stringify(bodyData);

        const requestAjax = await ajaxUtils.postOK(urlApi, jsonRequest, '', '');

        if (!requestAjax) {
          alertUtils.alertError('Erro ao criar Menu!');
          return false;
        }

        await this.pesquisarDadosRestSoap(nomeTipo, true);


        alertUtils.alertSuccess('Menu criado com sucesso!');
        this.closeModalRestSoap();
        return true;

      } catch (e) {
        console.error(e);
        alertUtils.alertError('Erro ao criar Menu!', 'Fechar');
        return false;

      } finally {
        loaderUtils.removeLoader();
      }
    },



    async pesquisarDadosRestSoap(tipo, silent = false) {
      loaderUtils.addLoarder();

      try {
        const tipoConvertido = (tipo === 'soap') ? 'S' : 'R';

        const urlApi =
          '/massificados/corporativo/gerenciador-parceiros/rest/manutencao-catalogo-servico/consulta-catalogo-menu/' +
          this.idCatalogo + '/' + tipoConvertido;

        const response = await fetch(urlApi, { method: 'GET' });

        if (response.status === 204) {
          this.$emit('atualizar-listas', { listaMenuCatalogoApi: [] });
          return [];
        }

        if (!response.ok) {
          if (!silent) alertUtils.alertError('Não encontramos nenhum resultado!', 'Fechar');
          return [];
        }

        const data = await response.json();
        const lista = Array.isArray(data) ? data : [];

        // ✅ atualiza via pai (dono do array)
        this.$emit('atualizar-listas', { listaMenuCatalogoApi: lista });

        // (opcional) se realmente precisar disso, mantenha
        for (let i = 0; i < lista.length; i++) {
          await this.pesquisarServicoMenu(this.idCatalogo, lista[i].codigo, lista);
        }

        return lista;

      } catch (e) {
        console.error(e);
        if (!silent) alertUtils.alertError('Não encontramos nenhum resultado!', 'Fechar');
        return [];
      } finally {
        loaderUtils.removeLoader();
      }
    },


    async buscarNomeCatalogo() {
      let nomeCatalogo = this.listas.nome;

      if (nomeCatalogo) nomeCatalogo = nomeCatalogo.replace("-clone", " Clone");

      this.nomeCatalogo = nomeCatalogo;
    },
    async pesquisar(grupo) {
      loaderUtils.addLoarder();

      let urlApi;
      let method;
      let requestOptions;

      urlApi = '/massificados/corporativo/gerenciador-parceiros/rest/manutencao-catalogo-servico/consulta-catalogo/' + this.idCatalogo;
      method = 'GET';

      requestOptions = {
        method: method
      };

      try {
        fetch(urlApi, requestOptions)
          .then(async (response) => {
            if (response.ok) {
              return response.json();
            } else {
              throw new Error('Fechar');
            }
          })
          .then((data) => {
            this.showList = true;

            this.listas = data;
            this.listaAutenticacaoCatalogoApi = data.listaAutenticacaoCatalogoApi;
            this.listaMenuCatalogoApi = data.listaMenuCatalogoApi;

            this.verificandoRestSoapMenu();
            this.buscarNomeCatalogo();
            loaderUtils.removeLoader();
          })
          .catch((error) => {
            loaderUtils.removeLoader();
            console.log(error);
            alertUtils.alertError('Não encontramos nenhum resultado!', 'Fechar');
          }).finally(() => 'loaderUtils.removeLoader()');

      } catch (error) {
        console.error('Erro ao realizar busca:', error);
        alertUtils.alertError('Erro ao realizar busca:' + error);
      }
    },



  }
};
</script>



<style scoped>
.loader {
  position: fixed;
  top: 0;
  left: 0;

  width: 100vw;
  height: 100vh;

  background: rgba(0, 0, 0, 0.65);

  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
